import {
    ableProps,
    ablePropsInit,
    requiredProps,
    requiredPropsInit,
    events as baseEvents,
} from '../component-base/props';
export const props = () => [
    ...ableProps,
    ...requiredProps,
    {
        key: 'placeholder',
        label: '占位文字',
        type: 'string',
    },
    {
        key: 'buttonText',
        label: '按钮文字',
        type: 'string',
    },
    {
        key: 'countdownSecond',
        label: '倒计时秒数',
        type: 'number',
    },
    {
        key: 'countdownText',
        label: '倒计时文字',
        type: 'string',
        props: {
            placeholder: '秒数会自动拼入',
        },
    },
    {
        key: 'relatedMobile',
        label: '关联的电话输入组件',
        type: 'uuid-select',
        props: {
            multiple: false,
            apiOnly: false,
        },
    },
    {
        key: 'maxlength',
        label: '最大长度',
        type: 'number',
    },
    {
        key: 'errMobile',
        label: '关联电话组件非法提示文案',
        type: 'string',
    },
    {
        // 空串表示无正则校验
        key: 'pattern',
        label: '校验正则表达式',
        type: 'string',
    },
    {
        key: 'errPattern',
        label: '正则表达式提示文案',
        type: 'string',
    },
    {
        key: 'sendUrl',
        label: '请求验证码接口',
        type: 'string',
    },
    {
        key: 'mobileKey',
        label: '发请求时电话号码字段名',
        type: 'string',
    },
    {
        key: 'countryCode',
        label: '国家码',
        type: 'string',
    },
    {
        key: 'extraPayload',
        label: '请求附加参数',
        type: 'object',
    },
];

export const init = () => ({
    ...ablePropsInit,
    ...requiredPropsInit,
    placeholder: '',
    buttonText: '获取验证码',
    countdownSecond: 60,
    countdownText: 's',
    relatedMobile: null,
    errMobile: '',
    maxlength: 4,
    pattern: '',
    errPattern: '',
    sendUrl: '',
    mobileKey: 'mobile',
    countryCode: '+86',
    extraPayload: {},
});

export const name = '手机号验证码';

export const component = 'mobile-general-form-mobile-captcha';

export const events = [
    'user-input',
    'change',
    ...baseEvents,
];
